import { useCallback } from 'react';
import { FormikValues } from '../hooks/CreateProjectContext';
import { FormikErrors } from 'formik';
import { connections, repository } from '../../../../@xmcloud/core/messages/en';
import {
	useValidateRepositoryName,
	useValidateSourceControlIntegrationV2,
} from '../../../services/repositories';
import { REPOSITORY, SOURCE_CONTROL_INTEGRATION_ID } from '../helpers';

export const useOLDGithubValidation = (
	values: FormikValues,
	errors: FormikErrors<FormikValues>,
	setFieldTouched: any,
	setFieldError: any,
	next: () => void,
) => {
	const { refetch: validateRepositoryName, isFetching: isLoadingRepoName } =
		useValidateRepositoryName(
			values.repository,
			values.sourceControlIntegrationId,
		);

	const {
		isFetching: isSourceControlIntegrationLoading,
		isIntegrationIdValidationValid,
		integrationValidationErrorMsg,
	} = useValidateSourceControlIntegrationV2({
		integrationId: values.sourceControlIntegrationId,
		enabled: !!values.sourceControlIntegrationId,
	});

	const isLoading = isLoadingRepoName || isSourceControlIntegrationLoading;

	const handleNext = useCallback(async () => {
		if (!values.sourceControlIntegrationId || !values.repository) {
			if (!values.sourceControlIntegrationId) {
				setFieldTouched(SOURCE_CONTROL_INTEGRATION_ID, true);
				setFieldError(
					SOURCE_CONTROL_INTEGRATION_ID,
					connections.requiredConnection,
				);
			}
			if (!values.repository) {
				setFieldTouched(REPOSITORY, true);
				setFieldError(REPOSITORY, repository.requiredRepositoryName);
			}
			return;
		}

		if (errors.sourceControlIntegrationId || errors.repository) return;
		if (values.isByoc) {
			next();
			return;
		}

		if (!isIntegrationIdValidationValid) {
			setFieldError(
				SOURCE_CONTROL_INTEGRATION_ID,
				integrationValidationErrorMsg,
			);
			return;
		}

		const { data: dataRepositoryName } = await validateRepositoryName();
		const isValidRepositoryName = dataRepositoryName?.data.isValid;
		const messageRepositoryName = dataRepositoryName?.data
			.message as string;

		if (!isValidRepositoryName) {
			setFieldError(REPOSITORY, messageRepositoryName);
			return;
		}

		next();
	}, [
		values.sourceControlIntegrationId,
		values.repository,
		values.isByoc,
		errors.sourceControlIntegrationId,
		errors.repository,
		isIntegrationIdValidationValid,
		validateRepositoryName,
		next,
		setFieldTouched,
		setFieldError,
		integrationValidationErrorMsg,
	]);

	return {
		handleNext,
		isLoading,
		isIntegrationIdValidationValid,
		integrationValidationErrorMsg,
		isSourceControlIntegrationLoading,
	};
};
